
(function () {
  if (window.giftWrappingInitialized) return;
  window.giftWrappingInitialized = true;

  const root = window.Shopify?.routes?.root || '/';

  const GIFT_HANDLE = 'products-gift-wrapping';
  const ATTR_KEY = 'ギフトラッピング';
  const ATTR_VALUE = 'あり（注意事項表示済み）';

  // ===== 通信中の見た目（押した瞬間に反応を見せる） =====
  const style = document.createElement('style');
  style.textContent =
    '.gift-wrapping-option{transition:opacity .15s ease;}' +
    '.gift-wrapping-option.is-loading{opacity:.5;pointer-events:none;}';
  document.head.appendChild(style);

  function startLoading(checkbox) {
    checkbox.closest('.gift-wrapping-option')?.classList.add('is-loading');
    // 合計金額を読み込み中表示（テーマ標準の shimmer）
    document.querySelectorAll('text-component[ref="cartTotal"]').forEach((el) => el.setAttribute('shimmer', ''));
  }

  function stopLoading(checkbox) {
    checkbox.closest('.gift-wrapping-option')?.classList.remove('is-loading');
    document.querySelectorAll('text-component[ref="cartTotal"][shimmer]').forEach((el) => el.removeAttribute('shimmer'));
  }

  // ===== カートドロワー下部（合計・ボタン）の固定ON/OFFを計算し直す =====
  // テーマ標準では「カートを開いたとき」にだけ計算されるため、
  // 開いたまま注意書きが増えると、下部が大きいまま固定されて商品一覧が押しつぶされる。
  // テーマと同じ基準（下部が画面の高さの半分を超えたら固定しない）で計算し直す。
  const SUMMARY_THRESHOLD = 0.5;

  function updateCartDrawerSticky() {
    document.querySelectorAll('dialog.cart-drawer__dialog').forEach((dialog) => {
      const summary = dialog.querySelector('.cart-drawer__summary');
      if (!summary) {
        dialog.setAttribute('cart-summary-sticky', 'false');
        return;
      }
      const drawerHeight = dialog.getBoundingClientRect().height;
      if (!drawerHeight) return; // 閉じているときは何もしない
      const ratio = summary.getBoundingClientRect().height / drawerHeight;
      dialog.setAttribute('cart-summary-sticky', ratio > SUMMARY_THRESHOLD ? 'false' : 'true');
    });
  }

  function scheduleStickyUpdate() {
    // テーマがカートを描き直した後に計算する
    requestAnimationFrame(() => requestAnimationFrame(updateCartDrawerSticky));
    setTimeout(updateCartDrawerSticky, 300);
  }

  window.addEventListener('resize', scheduleStickyUpdate);

  // ===== カート属性の後始末（ゴミ箱アイコンで削除した場合など） =====
  let syncing = false;
  let syncPending = false;

  async function syncGiftAttribute() {
    if (syncing) {
      syncPending = true;
      return;
    }
    syncing = true;

    try {
      const cartResponse = await fetch(root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      const cart = await cartResponse.json();

      const hasGift = (cart.items || []).some((item) => item.handle === GIFT_HANDLE);
      const current = cart.attributes ? cart.attributes[ATTR_KEY] : undefined;

      let next = null;
      if (hasGift && current !== ATTR_VALUE) next = ATTR_VALUE;
      if (!hasGift && current) next = ''; // 空文字で属性を削除

      if (next !== null) {
        await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ attributes: { [ATTR_KEY]: next } })
        });
      }
    } catch (error) {
      console.error('Gift wrapping attribute sync error:', error);
    } finally {
      syncing = false;
      if (syncPending) {
        syncPending = false;
        syncGiftAttribute();
      }
    }
  }

  document.addEventListener('cart:update', function (event) {
    // どの操作でカートが変わっても、ドロワー下部の固定を計算し直す
    scheduleStickyUpdate();

    // ラッピングのチェック以外でカートが変わったときだけ属性を同期する
    // （チェック操作では、属性も同じリクエストで更新済み）
    if (event.detail && event.detail.source === 'gift-wrapping') return;
    setTimeout(syncGiftAttribute, 0);
  });

  // ===== ラッピングのチェックボックス =====
  document.addEventListener('change', async function (event) {
    const checkbox = event.target.closest('.gift-wrapping-checkbox');
    if (!checkbox || checkbox.disabled) return;

    const variantId = Number(checkbox.dataset.variantId);
    const adding = checkbox.checked;

    if (!variantId) return;

    checkbox.disabled = true;
    startLoading(checkbox);

    let succeeded = false;

    try {
      // 更新対象のカートセクションを取得
      const sections = [
        ...new Set(
          [...document.querySelectorAll('cart-items-component[data-section-id]')]
            .map((element) => element.dataset.sectionId)
            .filter(Boolean)
        )
      ];

      // 数量・カート属性・画面の作り直しを1回のリクエストで行う
      const payload = {
        updates: { [variantId]: adding ? 1 : 0 },
        attributes: { [ATTR_KEY]: adding ? ATTR_VALUE : '' },
        sections: sections,
        sections_url: window.location.pathname
      };

      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Cart update failed: ' + response.status);
      }

      const cart = await response.json();

      if (cart.sections && sections.length) {
        // Atelierテーマのカート更新イベントを通知（カートを描き直す）
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: cart,
              source: 'gift-wrapping',
              sections: cart.sections
            }
          })
        );
        succeeded = true;
      } else {
        throw new Error('Cart sections unavailable');
      }

    } catch (error) {
      console.error('Gift wrapping error:', error);
      checkbox.checked = !adding;
      alert('ギフトラッピングの更新に失敗しました。');
    } finally {
      checkbox.disabled = false;
      // 成功時は描き直しで自然に戻るが、念のため解除する
      stopLoading(checkbox);
      if (!succeeded) {
        document.querySelectorAll('.gift-wrapping-option.is-loading').forEach((el) => el.classList.remove('is-loading'));
      }
      scheduleStickyUpdate();
    }
  });
})();
